export class UserOfficeModel{
    userId:number;
    officeId:number;
    isMainOffice:boolean;
}